import React from 'react';

import ToggleItem from '../../../modules/toggle-item/toggle-item';
import { SORT_DIRECTION } from '../../../types';

interface OrdersHeaderItemProps {
  title: string;
  direction?: SORT_DIRECTION;
  toggle?: boolean;
  onChangeToggle?: (direction: SORT_DIRECTION) => void;
}

const OrdersHeaderItem: React.FC<OrdersHeaderItemProps> = ({
  title,
  toggle,
  direction,
  onChangeToggle,
}) => (
  <div className="orders__header-item">
    <ToggleItem
      title={title}
      onChangeToggle={onChangeToggle}
      direction={direction}
      toggle={toggle}
    />
  </div>
);

export default OrdersHeaderItem;
